/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$tooltip-default-radius: 3px !default;
$tooltip-default-shadow: none !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  position: absolute;
  display: block;
  box-sizing: border-box;
  inline-size: max-content;
  visibility: hidden;
  opacity: 0;
  z-index: 100;
  pointer-events: none;
  @include eon-typography();
  @include slotted-margins("*:not([slot])");

  * {
    width: fit-content;
  }
}

:host(.#{$prefix}apply-transition) {
  transition-property: visibility, opacity;
  transition-duration: 200ms;
  transition-timing-function: ease-in-out;
}

:host(.#{$prefix}visible) {
  visibility: visible;
  opacity: 1;
  pointer-events: all;
}

:host([data-popper-placement^="top"]) {
  #arrow {
    bottom: -4px;
  }
}

:host([data-popper-placement^="bottom"]) {
  #arrow {
    top: -4px;
  }
}

:host([data-popper-placement^="left"]) {
  #arrow {
    right: -4px;

    &[data-hide] {
      right: 10px;
    }
  }
}

:host([data-popper-placement^="right"]) {
  #arrow {
    left: -4px;

    &[data-hide] {
      left: 10px;
    }
  }
}

.#{$prefix}wrapper {
  position: relative;
  max-width: 360px;
  padding: 24px;
  border-radius: $tooltip-default-radius;
  box-shadow: $tooltip-default-shadow;
  color: v(innerContentColor);
  background: v(backgroundColor);
  box-sizing: border-box;

  &.#{$prefix}small-size {
    padding: 7px 12px;
  }

  @include for-size(phone) {
    max-width: 288px;
    padding: 16px;
  }

  .#{$prefix}inner {
    position: relative;
    display: flex;
    flex-direction: column;

    &.#{$prefix}alignment-left {
      align-items: flex-start;
      text-align: left;
    }

    &.#{$prefix}alignment-center {
      align-items: center;
      text-align: center;
    }

    &.#{$prefix}alignment-right {
      align-items: flex-end;
      text-align: right;
    }
  }

  #arrow {
    position: absolute;
    width: 8px;
    height: 8px;
    background: v(backgroundColor);
    visibility: hidden;
  }

  .#{$prefix}apply-trasition {
    transition-property: left, right;
    transition-duration: 200ms;
    transition-timing-function: ease-in-out;
  }

  #arrow::before {
    position: absolute;
    left: 0;
    top: 0;
    width: 8px;
    height: 8px;
    background: inherit;
    visibility: visible;
    content: "";
    transform: rotate(45deg);
  }
}

::slotted(eon-ui-link) {
  --contentColor: var(--innerContentColor) !important;
  --contentHoverColor: var(--innerContentColor) !important;
}

::slotted(eon-ui-headline) {
  color: v(innerContentColor);
}

::slotted(*) {
  @include eon-typography(copy);
  color: v(innerContentColor);
}

::slotted(*:not([slot])) {
  margin-bottom: 16px !important;
}

::slotted(*:not([slot]):last-child) {
  margin-bottom: 0 !important;
}
